import { render, staticRenderFns } from "./storeMapping.vue?vue&type=template&id=1477372e&scoped=true"
import script from "./storeMapping.vue?vue&type=script&lang=js"
export * from "./storeMapping.vue?vue&type=script&lang=js"
import style0 from "./storeMapping.vue?vue&type=style&index=0&id=1477372e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477372e",
  null
  
)

export default component.exports